export default __webpack_public_path__ + "static/media/conduitEdit2.cf0a74ad.jpg";